<template>  
  <div class="d-flex align-items-center w-100" v-if="view === 'long'">
    <div class="cover-placeholder" style="width: 25%; max-width: 25%;">
        <transition name="fade">
          <div
            v-if="onFavs"
            style="
    position: absolute;
    z-index: 10;
    right: -2px;
    top: -7px;
    width: 35%;
    filter: drop-shadow(2px 4px .25rem rgba(0,0,0,.5));"
          >
            <img src="@/assets/favorite.svg" />
          </div>
        </transition>
        <img :src="imgCover" />
        <img
          v-if="promo"
          :src="$store.state.user.siteData.location +
              'repository/promos/' + promo"
          style="
            position: absolute;
            top: -50px;
            left: 0px;"      
          />
      </div>
      <div class="pl-3" style="width: 25%; max-width: 25%;">
        <div
          style="font-weight: 400; margin-bottom: .3rem; font-family: 'Poppins', sans-serif; line-height: 1.3;"
        >
          {{ bookTitle }}
        </div>
        <div style="font-size:small;" v-if="!escombo">{{ bookDesc }}</div>
      </div>
      <div class="pl-3" style="width: 25%; max-width: 25%;">
        <div class="d-flex justify-content-between">
          <b-button
            class="m-1 flex-fill"
            v-b-tooltip.hover
            title="Sin stock"
            style="border-radius: 0.7rem;background: rgb(192 205 217);border: #6c757d;"
            v-if="bookStock - onCart <= 0"
          >
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
              v-if="onCart === 0"
            >
              &times;
            </div>
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
              v-if="onCart !== 0"
            >
              {{ onCart }}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
          </b-button>
          <b-button
            class="m-1 flex-fill"
            @click="addItem()"
            v-b-tooltip.hover
            title="Agregar al carrito"
            style="border-radius: .7rem;"
            v-else-if="onCart === 0"
          >
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
            >
              +
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
          </b-button>
          <b-button
            class="m-1 flex-fill cartActive"
            @click="addItem()"
            v-b-tooltip.hover
            title="Agregar al carrito"
            style="border-radius: .7rem; background: #e8661a; border:none;"
            v-else
          >
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
            >
              {{ onCart }}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
          </b-button>
          <b-button
            class="m-1 flex-fill"
            variant="light"
            v-b-tooltip.hover
            title="Ver detalle"
            style="border-radius: .7rem; color: #21252999;"
            @click="showModal()"
          >
            <font-awesome-icon icon="eye" />
          </b-button>

          <b-button
            class="m-1 flex-fill"
            variant="light"
            v-b-tooltip.hover
            title="Agregar a favoritos"
            v-if="!onFavs"
            @click="addToFav()"
            style="border-radius: .7rem; color: #21252999;"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="far"
              data-icon="heart"
              class="svg-inline--fa fa-heart fa-w-16"
              role="img"
              viewBox="0 0 512 512"
              width="1em"
              height="1em"
            >
              <path
                fill="currentColor"
                d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
              />
            </svg>
          </b-button>
          <b-button
            class="m-1 flex-fill"
            v-b-tooltip.hover
            title="Quitar de favoritos"
            v-if="onFavs"
            @click="removeFromFav()"
            style="border-radius: .7rem;"
          >
            <font-awesome-icon icon="heart" />
          </b-button>
        </div>
      </div>
      <div class="pl-3" style="width: 25%; max-width: 25%;">
        <div
          class="my-2 p-2 text-center"
          style="font-weight: bold;"
          v-if="showPrices"
        >
          <span style="color: #b3b3b3; text-decoration: line-through;" v-if="bookPrice !== bookRegular">${{bookRegular}}</span>
          ${{bookPrice}}
        </div>
      </div>
  </div>
  <b-card class="border-0 book-thumbnail" v-else :style="calcSize">
    <b-card-text>
      <div class="cover-placeholder">
        <transition name="fade">
          <div
            v-if="onFavs"
            style="
    position: absolute;
    z-index: 10;
    right: -2px;
    top: -7px;
    width: 35%;
    filter: drop-shadow(2px 4px .25rem rgba(0,0,0,.5));"
          >
            <img src="@/assets/favorite.svg" />
          </div>
        </transition>
        <img :src="imgCover" />
        <img
          v-if="promo"
          :src="$store.state.user.siteData.location +
            'repository/promos/' + promo" 
          style="
            position: absolute;
            top: -50px;
            left: 0px;"      
          />
      </div>
      <div
        class="w-75"
        style="line-height: 1rem; cursor: pointer;"
        @click="openDetails()"
      >
        <div
          style="font-weight: 400; margin-bottom: .3rem; font-family: 'Poppins', sans-serif; line-height: 1.3;"
        >
          {{ bookTitle }}
        </div>
        <div style="font-size:small;" v-if="!escombo">{{ bookDesc }}</div>
      </div>
    </b-card-text>
    <b-card-footer>
      <div
        class="my-2 p-2 text-center"
        style="border-top: 1px solid #b3b3b3; border-bottom: 1px solid #b3b3b3; font-weight: bold;"
        v-if="showPrices"
      >
        <span style="color: #b3b3b3; text-decoration: line-through;" v-if="bookPrice !== bookRegular">${{bookRegular}}</span>
        ${{bookPrice}}
      </div>
      <div class="mt-3 d-flex justify-content-between">
        <b-button
            class="m-1 flex-fill"
            v-b-tooltip.hover
            title="Sin stock"
            style="border-radius: 0.7rem;background: rgb(192 205 217);border: #6c757d;"
            v-if="bookStock - onCart <= 0"
          >
            
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
              v-if="onCart === 0"
            >
              &times;
            </div>
            <div
              style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
              v-if="onCart !== 0"
            >
              {{ onCart }}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="white"
              width="1.2rem"
              height="1.2rem"
            >
              <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
              <path
                id="svg_2"
                d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
              />
            </svg>
            
          </b-button>
        <b-button
          class="m-1 flex-fill"
          @click="addItem()"
          v-b-tooltip.hover
          title="Agregar al carrito"
          style="border-radius: .7rem;"
          v-else-if="onCart === 0"
        >
          <div
            style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
          >
            +
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            width="1.2rem"
            height="1.2rem"
          >
            <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
            <path
              id="svg_2"
              d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
            />
          </svg>
        </b-button>
        <b-button
          class="m-1 flex-fill cartActive"
          @click="addItem()"
          v-b-tooltip.hover
          title="Agregar al carrito"
          style="border-radius: .7rem; background: #e8661a; border:none;"
          v-else
        >
          <div
            style="font-size: xx-small;margin: -4px 0px -.7rem;text-align: center;"
          >
            {{ onCart }}
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            width="1.2rem"
            height="1.2rem"
          >
            <path id="svg_1" fill="none" d="m0,0l24,0l0,24l-24,0l0,-24z" />
            <path
              id="svg_2"
              d="m7.40705,18.67842c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm10,0c-1.1,0 -1.99,0.9 -1.99,2s0.89,2 1.99,2s2,-0.9 2,-2s-0.9,-2 -2,-2zm-9.83,-3.25l0.03,-0.12l0.9,-1.63l7.45,0c0.75,0 1.41,-0.41 1.75,-1.03l3.86,-7.01l-1.74,-0.96l-0.01,0l-1.1,2l-2.76,5l-7.02,0l-0.13,-0.27l-2.24,-4.73l-0.95,-2l-0.94,-2l-3.27,0l0,2l2,0l3.6,7.59l-1.35,2.45c-0.16,0.28 -0.25,0.61 -0.25,0.96c0,1.1 0.9,2 2,2l12,0l0,-2l-11.58,0c-0.13,0 -0.25,-0.11 -0.25,-0.25z"
            />
          </svg>
        </b-button>
        <b-button
          class="m-1 flex-fill"
          variant="light"
          v-b-tooltip.hover
          title="Ver detalle"
          style="border-radius: .7rem; color: #21252999;"
          @click="showModal()"
        >
          <font-awesome-icon icon="eye" />
        </b-button>

        <b-button
          class="m-1 flex-fill"
          variant="light"
          v-b-tooltip.hover
          title="Agregar a favoritos"
          v-if="!onFavs"
          @click="addToFav()"
          style="border-radius: .7rem; color: #21252999;"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            data-prefix="far"
            data-icon="heart"
            class="svg-inline--fa fa-heart fa-w-16"
            role="img"
            viewBox="0 0 512 512"
            width="1em"
            height="1em"
          >
            <path
              fill="currentColor"
              d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
            />
          </svg>
        </b-button>
        <b-button
          class="m-1 flex-fill"
          v-b-tooltip.hover
          title="Quitar de favoritos"
          v-if="onFavs"
          @click="removeFromFav()"
          style="border-radius: .7rem;"
        >
          <font-awesome-icon icon="heart" />
        </b-button>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    imgCover: String,
    bookTitle: String,
    bookDesc: String,
    bookId: Number,
    size: Number,
    showPrices: Boolean,
    bookPrice: Number,
    bookRegular: Number,
    bookStock: Number,
    view: String,
    promo: String,
    escombo: Boolean
  },
  data() {
    return {
      cartAnim: false
    };
  },
  computed: {
    onCart: function() {
      if (this.escombo) {
        return this.$store.getters.getItemByType({ id: this.bookId, type: 5 });
      } else {
        return this.$store.getters.getItemById(this.bookId);
      }
    },
    onFavs: function() {
      let favBookIndex = 0;
      if (this.escombo) {
        favBookIndex = this.$store.getters.getFavItemByType({ id: this.bookId, type: 5 });
      } else {
        favBookIndex = this.$store.getters.getFavItemById(this.bookId);
      }
      if (favBookIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
    calcSize: function() {
        const w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
        console.log(w);
        if (w > 768){
          return (
            "width: calc(" +
            this.size +
            "% - 15px); min-width: calc(" +
            this.size +
            "% - 15px);"
          );
        }else{
          return (
            "width: calc(100% - 15px); min-width: calc(100% - 15px);"
            );
        }
      
    }
  },
  methods: {
    addItem: function() {
      if (this.escombo) {
        this.addCartItem({id: this.bookId, type: 5});
      } else {
        this.addCartItem(this.bookId);
      }
    },
    addToFav: function() {
      if (this.escombo) {
        this.addFavItem({id: this.bookId, type: 5});
      } else {
        this.addFavItem(this.bookId);
      }
    },
    removeFromFav: function() {
      if (this.escombo) {
        this.removeFavItem({id: this.bookId, type: 5});
      } else {
        this.removeFavItem(this.bookId);
      }
    },
    showModal: function() {
      this.$parent.showModal(this.bookId, this.escombo);
    },
    openDetails: function() {
      if (this.escombo) {
        this.$router.push({ path: `/combo/${this.bookId}` });
      } else {
        this.$router.push({ path: `/detalles/${this.bookId}` });
      }
      this.$emit('selbook');
    },
    ...mapActions(["addCartItem", "addFavItem", "removeFavItem"])
  }
};
</script>
